import React from 'react';
import { Link } from 'react-router-dom';
interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  to?: string;
  href?: string;
  children: ReactNode;
  className?: string;
}
export function Button({
  variant = 'primary',
  size = 'md',
  to,
  href,
  children,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-all duration-300 ease-out rounded-sm';
  const variants = {
    primary: 'bg-gold text-black hover:bg-goldHover shadow-[0_0_15px_rgba(200,255,0,0.15)] hover:shadow-[0_0_25px_rgba(200,255,0,0.3)]',
    secondary: 'border border-gold text-gold hover:bg-gold/10',
    ghost: 'text-white hover:text-gold'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  const classes = `${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`;
  if (to) {
    return <Link to={to} className={classes} data-id="element-113">
        {children}
      </Link>;
  }
  if (href) {
    return <a href={href} className={classes} target="_blank" rel="noopener noreferrer" data-id="element-114">
        {children}
      </a>;
  }
  return <button className={classes} {...props} data-id="element-115">
      {children}
    </button>;
}